import {
    getEmployees,
    getDocumentTypes,
    getPayrules,
    getEmployeePayRules,
    setEmployeePayRules,
    getEmployeeById,
    addEmployee,
    updateEmployee,
    getAccrualProfiles,
    getEmployeeAccrualProfiles,
    createEmployeeAccrualProfiles,
    updateEmployeeAccrualProfiles,
    getOrgpathByEmployeeId,
} from './employee';
import { assignTagsToEmployee, createTag, getTags, getTagsByEmployee, replaceEmployeeTagRanges } from './tag';
import { createEmployeeScheduleRules, deleteEmployeeScheduleRule, getEmployeeScheduleRules, getScheduleRules, updateEmployeeScheduleRule } from './scheduleRule';
import { createHiringRange, deleteHiringRange, getHiringRanges, updateHiringRange } from './hiringRange';
import { createHiring, deleteHiring, getHiring, updateHiring } from './hiring';
import { getSubcompany } from './subCompany';
import { getArea } from './areas';
import { getWorkPosition } from './workPosition';
import { assignHiringOrgpath, getHiringOrgpath, updateHiringOrgpath } from './hiringOrgpath';
import { getOrgPathTree } from './orgpath';

const employeeService = {
    getTags,
    getEmployees,
    getDocumentTypes,
    getPayrules,
    getEmployeePayRules,
    setEmployeePayRules,
    getEmployeeById,
    addEmployee,
    updateEmployee,
    getAccrualProfiles,
    getEmployeeAccrualProfiles,
    createEmployeeAccrualProfiles,
    updateEmployeeAccrualProfiles,
    getOrgPathTree,
    createTag,
    assignTagsToEmployee,
    getTagsByEmployee,
    replaceEmployeeTagRanges,
    getScheduleRules,
    getEmployeeScheduleRules,
    createEmployeeScheduleRules,
    updateEmployeeScheduleRule,
    deleteEmployeeScheduleRule,
    getHiringRanges,
    createHiringRange,
    updateHiringRange,
    deleteHiringRange,
    getHiring,
    createHiring,
    updateHiring,
    deleteHiring,
    getSubcompany,
    getArea,
    getWorkPosition,
    getHiringOrgpath,
    assignHiringOrgpath,
    updateHiringOrgpath,
    getOrgpathByEmployeeId,
};

export { employeeService };
